import { ThemeOptions } from '@mui/system';

const SPACING = 4;

export const spacing: ThemeOptions['spacing'] = (factor: number) => SPACING * factor;
